import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import apiClient from "common/src/api/ApiClient";
import {browserTimeZone, dateToString} from "common/src/utils/DateUtils";

/* ------------------ Slice ------------------ */
const statisticsDataAPI = createSlice({
  name: "statisticsData",
  initialState: {
    overloadedAxleStatistic: { loading: false, data: [] },
    vehicleSpeedStatistic: { loading: false, data: [] },
    hourlyVehicleStatistic: { loading: false, data: [] },
    dailyVehicleStatistic: { loading: false, data: [] },
    sites: { loading: false, data: {}, ids: [], error: null },
    list: [],
    loading: false,
    details: null,
    loadingDetails: false,
  },
  reducers: {
    clearDatasetDetails: (state) => {
      state.details = null;
      state.loadingDetails = false;
    },
    clearDatasetList: (state) => {
      state.list = [];
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
    /* Aggregated Daily (sites) */
    .addCase(fetchVehicleSiteDailyAggregations.pending, (state) => {
      state.sites.loading = true;
    })
    .addCase(fetchVehicleSiteDailyAggregations.fulfilled, (state, action) => {
      state.sites.loading = false;
      state.sites.data = action.payload;
      state.sites.ids = Object.keys(action.payload);
      state.sites.error = null;
    })
    .addCase(fetchVehicleSiteDailyAggregations.rejected, (state, action) => {
      state.sites.loading = action.error.message === "Request was aborted";
      state.sites.error = action.error;
    });
  },
});

export const fetchVehicleSiteDailyAggregations = createAsyncThunk(
    "dataset/fetch/aggregated-daily",
    async ({ from, to, sites }) => {
      from = !!from ? dateToString(from, true, false) : "";
      to = !!to ? dateToString(to, true, false) : "";
      const baseUrl = `/api/v1/statistics/`;
      const repeatedKeys = sites.map(loc => `site=${encodeURIComponent(loc)}`).join('&');
      const timeZone = encodeURIComponent(browserTimeZone());
      const fullUrl = `${baseUrl}?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&timeZone=${timeZone}&${repeatedKeys}`;

      const response = await apiClient.get(fullUrl, {}, null, null, null);
      return response.data.payload;
    }
);

export const {clearDatasetDetails, clearDatasetList} = statisticsDataAPI.actions;
export default statisticsDataAPI.reducer;
